module.exports = __webpack_public_path__ + "media/images/menu/leo-14dab324fffc85bd6cd4ce060e6aba1e.jpg";